import React from 'react';
import { Box, Card, CardContent, Stack, Typography, Divider, Link, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import Confetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';
import { useFullScreen, useResponsive } from '../../services/hooks';

export default function FormSent({ identifier, data, model }) {
  const isMobile = useFullScreen();
  const { width, height } = useWindowSize();

  const handleLinkClick = link => {
    window.open(link, '_blank');
  };

  return !isMobile ? (
    <Box>
      {!['karta_kwalifikacyjna', 'umowa_zawarta', 'aneks_zawarty'].includes(identifier) && <Confetti height={height} width={width} />}
      <Box />
      <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Card>

          <CardContent>
            <Stack justifyContent="center" alignItems="center">
              <CheckCircleOutlineIcon color="primary" sx={{ fontSize: '100px', mb: 3 }} />
              <Typography variant="h3" textAlign="center" whiteSpace="pre-line">
                {identifier.startsWith('ankieta_dzieci')
                  ? 'Otrzymaliśmy Twoją ankietę! Dziękujemy 😊'
                  : identifier.startsWith('ankieta_nauczyciele')
                    ? 'Państwa opinia jest dla nas ważna! Dziękujemy za wypełnienie ankiety.'
                    : identifier.startsWith('ankieta_rodzice')
                      ? 'Bardzo dziękujemy za podzielenie się z nami wszystkimi uwagami!\n\n Specjalnie dla Państwa wygenerowaliśmy jednorazowy kod rabatowy BXJ7EDU4EL o wartości 50 zł na obóz letni Sun Sport 2024! Rabat ten łączyć się będzie z rabatem dla Stałego Klienta 😊'
                      : identifier.startsWith('kwestionariusz')
                        ? 'Kwestionariusz został przesłany'
                        : identifier.startsWith('umowa_zawarta')
                          ? 'Umowa została zawarta'
                          : identifier.startsWith('aneks_zawarty')
                            ? 'Aneks został zawarty'
                            : identifier.startsWith('karta_kwalifikacyjna')
                              ? <>
                                {'Dokument został wysłany na Twój adres e-mail.\n\nWYDRUKUJ GO ➞ PODPISZ ➞ ZESKANUJ ➞ WYŚLIJ NA ADRES '}
                                <Link href={`mailto:${data.resort_email_address}`} color="primary">
                                  {data.resort_email_address.toUpperCase()}
                                </Link>
                                {`\nPAMIĘTAJ, ŻE MASZ CZAS OGRANICZONY DO ${data.completing_date_to}\n`}
                              </>
                              : 'Formularz został przesłany'
                }
              </Typography>
              <Typography variant="h3" textAlign="center" textTransform="none" fontWeight="normal">
                { model === 'EmployeeApplication' && identifier.startsWith('rekrutacja')
                  ? 'Dziękujemy. Skontaktujemy się z wybranymi osobami'
                  : identifier.startsWith('kwestionariusz')
                    ? 'Już wkrótce otrzymasz umowę na maila'
                    : identifier.startsWith('umowa_zawarta' && model === 'EmployeeApplication')
                      ? 'Zaakceptowaną umowę oraz dostęp do Twojego indywidualnego konta w Panelu Kartoteka przesłaliśmy na Twój adres e-mail'
                      : identifier.startsWith('umowa_zawarta')
                        ? 'Zaakceptowaną umowę przesłaliśmy na Twój adres e-mail'
                        : identifier.startsWith('aneks_zawarty')
                          ? 'Zaakceptowany aneks przesłaliśmy na Twój adres e-mail'
                          : ''
                }
              </Typography>
              { model === 'EmployeeApplication'
                ? <> <Box height={110}/>
                  <Typography textAlign="center" sx={{ fontSize: 26 }}><i>Ciesz się pasją, postaw na rozwój!</i></Typography>
                  <Typography textAlign="center" sx={{ fontSize: 26 }}>Dołącz do nas</Typography>
                  <Box
                    onClick={() => window.open('https://www.facebook.com/groups/160178924602264/')}
                    component="img"
                    src="/static/grupa.png"
                    sx={{ cursor: 'pointer', width: '100px', height: '80%', marginBottom: 3, marginTop: 2 }}
                  /> </>
                : null }
              <Box height={20} />
              {(['umowa_zawarta', 'aneks_zawarty'].includes(identifier) && model === 'Order' && data?.module == 'obozy') && <Stack direction="column" justifyContent="center" width="900px">
                <Box height={40} />
                <Typography textAlign="center" sx={{ fontSize: 26, mb: 2 }}>Zostały jeszcze <b>2 kroki:</b></Typography>

                {data.below_30_days_to_start || data.quick_payment_promotion
                  ? <Stack display="flex" direction="row" alignItems="center" justifyContent="center" mb={4}>
                    <Typography flex="1 1 15%" textAlign="center" sx={{ fontSize: 22 }}><b>KROK 1</b> &nbsp;</Typography>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" flex="1 1 85%" >
                      <Button variant="contained" onClick={() => handleLinkClick(identifier === 'aneks_zawarty' ? data.left_to_pay_payment_url : data.full_payment_url)}><Typography textAlign="center" sx={{ fontSize: 22 }} >
                        {identifier === 'aneks_zawarty' ? 'ZAPŁAĆ POZOSTAŁĄ KWOTĘ' : 'ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI'}
                      </Typography></Button>
                    </Stack>
                  </Stack>
                  : <Stack display="flex" direction="row" alignItems="center" justifyContent="center" mb={4}>
                    <Typography flex="1 1 15%" textAlign="center" sx={{ fontSize: 22 }}><b>KROK 1</b> &nbsp;</Typography>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" flex="1 1 85%" >
                      <Button variant="contained" onClick={() => handleLinkClick(data.advance_payment_url)}><Typography textAlign="center" sx={{ fontSize: 22 }} >
                        ZAPŁAĆ ZALICZKĘ
                      </Typography></Button>
                      <Typography textAlign="center" sx={{ fontSize: 22 }}>&nbsp; lub &nbsp;</Typography>
                      <Button variant="contained" onClick={() => handleLinkClick(identifier === 'aneks_zawarty' ? data.left_to_pay_payment_url : data.full_payment_url)}><Typography textAlign="center" sx={{ fontSize: 22 }} >
                        {identifier === 'aneks_zawarty' ? 'ZAPŁAĆ POZOSTAŁĄ KWOTĘ' : 'ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI'}
                      </Typography></Button>
                    </Stack>
                  </Stack>}

                <Stack direction="row" alignItems="center" width="100%" mb={7}>
                  <Typography textAlign="center" sx={{ fontSize: 22 }} flex="1 1 15%"><b>KROK 2</b> &nbsp;</Typography>
                  <Button
                    sx={{ justifyContent: 'center', textTransform: 'none', width: '100%', flex: '1 1 85%' }}
                    variant="contained"
                    onClick={() => handleLinkClick(data.qualification_card_url)}>
                    <Typography textAlign="center" sx={{ fontSize: 22 }} >
                      WYPEŁNIJ KARTĘ KWALIFIKACYJNĄ – kod w pierwszym sms-ie
                    </Typography>
                  </Button>
                </Stack>
                <Stack direction="row" alignItems="center">
                  <Box width={35} flex="1 1 15%" />
                  <Button
                    sx={{ mt: 2, mb: 2, flex: '1 1 85%' }}
                    variant="contained"
                    onClick={() => handleLinkClick('https://sun-sport.pl/lato/strefa-rodzica#ubezpieczenie')}>
                    <Typography textAlign="center" sx={{ fontSize: 22 }}>
                    ROZWAŻ UBEZPIECZENIE REZYGNACJI <br /> SPRAWDŹ CO SIĘ DZIEJE, JAK ZREZYGNUJESZ
                    </Typography>
                  </Button>
                </Stack>
                <Box height={20} />
              </Stack>
              }
              {(['umowa_zawarta', 'aneks_zawarty'].includes(identifier) && model === 'Order' && data?.module == 'wyjazdy_rodzinne') && <Stack direction="column" justifyContent="center" width="900px">
                <Box height={40} />
                <Typography textAlign="center" sx={{ fontSize: 26, mb: 2 }}>Możesz teraz:</Typography>
                <Divider flexItem />
                {data.quick_payment_promotion
                  ? <Stack display="flex" direction="row" alignItems="center" justifyContent="center" mb={4} mt={1} spacing={5}>
                    <Button variant="contained" onClick={() => handleLinkClick(data.left_to_pay_payment_url)}><Typography textAlign="center" sx={{ fontSize: 22 }} >
                      ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI
                    </Typography></Button>
                  </Stack>
                  : <Stack display="flex" direction="row" alignItems="center" justifyContent="center" mb={4} mt={1} spacing={5}>
                    <Button variant="contained" onClick={() => handleLinkClick(data.advance_payment_url)}><Typography textAlign="center" sx={{ fontSize: 22 }} >
                      ZAPŁAĆ ZALICZKĘ
                    </Typography></Button>
                    <Typography textAlign="center" sx={{ fontSize: 22 }}>&nbsp; lub &nbsp;</Typography>
                    <Button variant="contained" onClick={() => handleLinkClick(data.full_payment_url)}><Typography textAlign="center" sx={{ fontSize: 22 }} >
                      ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI
                    </Typography></Button>
                  </Stack>}
                <Box height={20} />
              </Stack>
              }
              { ['karta_kwalifikacyjna'].includes(identifier)
                ? <>
                  <Stack direction="row" alignItems="center">
                    <Button sx={{ mt: 2, justifyContent: 'left' }} variant="contained" size="large"
                      onClick={() => handleLinkClick('https://sun-sport.pl/lato/strefa-rodzica#ubezpieczenie')}>
                      <Typography textAlign="center">
                        MOŻESZ JESZCZE ROZWAŻYĆ<br />UBEZPIECZENIE REZYGNACJI Z WYJAZDU
                      </Typography>
                    </Button>
                  </Stack>
                  <Box height={40} />
                </>
                : null}
              <Stack direction="column" justifyContent="center" alignItems="center">
                {((['umowa_zawarta', 'aneks_zawarty'].includes(identifier) && model === 'Order') || identifier === 'karta_kwalifikacyjna')
                  ? <>
                    <Box height={40} />
                    <Divider sx={{ width: '100%' }}/>
                    <Box height={10} />
                    <Typography textAlign="center" sx={{ fontSize: 24 }}><i>W międzyczasie obserwuj nas i zawsze bądź na bieżąco</i></Typography>
                    <Stack flexDirection="row" gap={2}>
                      <a style={{ height: '80px', color: '#4267B2' }} href="https://www.facebook.com/kalisz.sun.sport" target="_blank" rel="noopener noreferrer">
                        <FacebookRoundedIcon sx={{ fontSize: 80 }} />
                      </a>
                      <a style={{ height: '80px' }} href="https://www.instagram.com/sun_sport.pl/" target="_blank" rel="noopener noreferrer">
                        <svg width={0} height={0}>
                          <radialGradient id="rg" r="150%" cx="30%" cy="107%">
                            <stop stopColor="#fdf497" offset="0" />
                            <stop stopColor="#fdf497" offset="0.05" />
                            <stop stopColor="#fd5949" offset="0.45" />
                            <stop stopColor="#d6249f" offset="0.6" />
                            <stop stopColor="#285AEB" offset="0.9" />
                          </radialGradient>
                        </svg>
                        <InstagramIcon sx={{ fill: 'url(#rg)', fontSize: 80 }}/>
                      </a>
                      <a style={{ height: '80px', color: 'red' }} href="https://www.youtube.com/@sun_sport_obozy" target="_blank" rel="noopener noreferrer">
                        <YouTubeIcon sx={{ fontSize: 80 }} />
                      </a>
                    </Stack>
                  </>
                  : null}
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Box>
      <Box />
    </Box>
  ) : (

  // WIDOK MOBILNY

    <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '95vh' }}>
      {!['karta_kwalifikacyjna', 'umowa_zawarta', 'aneks_zawarty'].includes(identifier) && <Confetti
        width={width}
        height={height}
      />}
      <Stack justifyContent="space-between" alignItems="center" spacing={0}>
        <CheckCircleOutlineIcon color="primary" sx={{ fontSize: '72px' }} />
        <Typography variant="h3" textAlign="center" whiteSpace="pre-line">
          {identifier.startsWith('ankieta_dzieci')
            ? 'Otrzymaliśmy Twoją ankietę! Dziękujemy 😊'
            : identifier.startsWith('ankieta_nauczyciele')
              ? 'Państwa opinia jest dla nas ważna! Dziękujemy za wypełnienie ankiety.'
              : identifier.startsWith('ankieta_rodzice')
                ? 'Bardzo dziękujemy za podzielenie się z nami wszystkimi uwagami!\n\n Specjalnie dla Państwa wygenerowaliśmy jednorazowy kod rabatowy BXJ7EDU4EL o wartości 50 zł na obóz letni Sun Sport 2024! Rabat ten łączyć się będzie z rabatem dla Stałego Klienta 😊'
                : identifier.startsWith('kwestionariusz')
                  ? 'Kwestionariusz został przesłany'
                  : identifier.startsWith('umowa_zawarta')
                    ? 'Umowa została zawarta'
                    : identifier.startsWith('aneks_zawarty')
                      ? 'Aneks został zawarty'
                      : identifier.startsWith('karta_kwalifikacyjna')
                        ? <>
                          {'Dokument został wysłany na Twój adres e-mail.\n\nWYDRUKUJ GO ➞ PODPISZ ➞ ZESKANUJ ➞ WYŚLIJ NA ADRES '}
                          <Link href={`mailto:${data.resort_email_address}`} color="primary">
                            {data.resort_email_address.toUpperCase()}
                          </Link>
                          {`\nPAMIĘTAJ, ŻE MASZ CZAS OGRANICZONY DO ${data.completing_date_to}\n`}
                        </>
                        : 'Formularz został przesłany'
          }
        </Typography>
        <Typography variant="h3" textAlign="center" textTransform="none" fontWeight="normal">
          { model === 'EmployeeApplication' && identifier.startsWith('rekrutacja')
            ? 'Dziękujemy. Skontaktujemy się z wybranymi osobami'
            : identifier.startsWith('kwestionariusz')
              ? 'Już wkrótce otrzymasz umowę na maila'
              : identifier.startsWith('umowa_zawarta' && model === 'EmployeeApplication')
                ? 'Zaakceptowaną umowę oraz dostęp do Twojego indywidualnego konta w Panelu Kartoteka przesłaliśmy na Twój adres e-mail'
                : identifier.startsWith('umowa_zawarta')
                  ? 'Zaakceptowaną umowę przesłaliśmy na Twój adres e-mail'
                  : identifier.startsWith('aneks_zawarty')
                    ? 'Zaakceptowany aneks przesłaliśmy na Twój adres e-mail'
                    : ''
          }
        </Typography>
        <Box height={30} />
        { model === 'EmployeeApplication'
          ? <>
            <Typography textAlign="center" sx={{ fontSize: 22 }}><i>Ciesz się pasją, postaw na rozwój!</i></Typography>
            <Typography textAlign="center" sx={{ fontSize: 22 }}>Dołącz do nas</Typography>
            <Box
              onClick={() => window.location.assign('https://www.facebook.com/groups/160178924602264/')}
              component="img"
              src="/static/grupa.png"
              sx={{ cursor: 'pointer', width: '100px', marginBottom: 3, marginTop: 2 }}
            />
          </>
          : null}
        {/* <Divider sx={{ width: '90%' }}/> */}
        <Box height={20} />
        {(['umowa_zawarta', 'aneks_zawarty'].includes(identifier) && model === 'Order' && data?.module == 'obozy') && <Stack direction="column" justifyContent="left" p={1}>
          <Typography sx={{ fontSize: 16 }} textAlign="center">Zostały jeszcze <b>2 kroki:</b></Typography>
          {data.below_30_days_to_start || data.quick_payment_promotion
            ? <Stack direction="row" alignItems="center" mb={2}>
              <Typography sx={{ fontSize: 12 }}>1. &nbsp;</Typography>
              <Button variant="contained" onClick={() => handleLinkClick(identifier === 'aneks_zawarty' ? data.left_to_pay_payment_url : data.full_payment_url)} ><Typography sx={{ fontSize: 10 }}>
                {identifier === 'aneks_zawarty' ? 'ZAPŁAĆ POZOSTAŁĄ KWOTĘ' : 'ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI'}
              </Typography></Button>
            </Stack>
            : <Stack direction="row" alignItems="center" mb={2}>
              <Typography sx={{ fontSize: 12 }}>1. &nbsp;</Typography>
              <Button variant="contained" onClick={() => handleLinkClick(data.advance_payment_url)}><Typography variant="caption" sx={{ fontSize: 10 }}>
                  ZAPŁAĆ ZALICZKĘ
              </Typography></Button>
              <Typography sx={{ fontSize: 12 }}>&nbsp; lub &nbsp;</Typography>
              <Button variant="contained" onClick={() => handleLinkClick(identifier === 'aneks_zawarty' ? data.left_to_pay_payment_url : data.full_payment_url)} ><Typography sx={{ fontSize: 10 }}>
                {identifier === 'aneks_zawarty' ? 'ZAPŁAĆ POZOSTAŁĄ KWOTĘ' : 'ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI'}
              </Typography></Button>
            </Stack>}

          <Stack direction="row" alignItems="center">
            <Typography sx={{ fontSize: 12 }}>2. &nbsp;</Typography>
            <Button sx={{ justifyContent: 'left', textTransform: 'none' }} variant="contained" onClick={() => handleLinkClick(data.qualification_card_url)}><Typography sx={{ fontSize: 12 }}>
                  WYPEŁNIJ KARTĘ KWALIFIKACYJNĄ – kod w pierwszym sms-ie
            </Typography></Button>
          </Stack>

          <Stack direction="row" alignItems="center" mb={1}>
            <Box width={3} />
            <Button sx={{ mt: 2, justifyContent: 'left' }} variant="contained" onClick={() => handleLinkClick('https://sun-sport.pl/lato/strefa-rodzica#ubezpieczenie')}><Typography sx={{ fontSize: 12 }}>
                  MOŻESZ JESZCZE ROZWAŻYĆ UBEZPIECZENIE REZYGNACJI Z WYJAZDU
            </Typography></Button>
          </Stack>

          <Divider />
          <Box height={20} />
        </Stack>
        }
        {(['umowa_zawarta', 'aneks_zawarty'].includes(identifier) && model === 'Order' && data?.module == 'wyjazdy_rodzinne') && <Stack direction="column" justifyContent="left" p={1}>
          <Typography sx={{ fontSize: 16 }} textAlign="center">Możesz teraz:</Typography>
          {data.quick_payment_promotion ? <Stack direction="row" alignItems="center" mb={2} mt={2}>
            <Button variant="contained" onClick={() => handleLinkClick(data.left_to_pay_payment_url)} ><Typography sx={{ fontSize: 10 }}>
                  ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI
            </Typography></Button>
          </Stack> : <Stack direction="row" alignItems="center" mb={2} mt={2}>
            <Button variant="contained" onClick={() => handleLinkClick(data.advance_payment_url)}><Typography variant="caption" sx={{ fontSize: 10 }}>
                  ZAPŁAĆ ZALICZKĘ
            </Typography></Button>
            <Typography sx={{ fontSize: 12 }}>&nbsp; lub &nbsp;</Typography>
            <Button variant="contained" onClick={() => handleLinkClick(data.full_payment_url)} ><Typography sx={{ fontSize: 10 }}>
                  ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI
            </Typography></Button>
          </Stack>}
          <Divider />
          <Box height={20} />
        </Stack>
        }
        { ['karta_kwalifikacyjna'].includes(identifier)
          ? <>
            <Stack direction="row" alignItems="center" mb={1}>
              <Button sx={{ mt: 2, justifyContent: 'left' }} variant="contained" size="large" onClick={() => handleLinkClick('https://sun-sport.pl/lato/strefa-rodzica#ubezpieczenie')}><Typography sx={{ fontSize: 16 }}>
                    MOŻESZ JESZCZE ROZWAŻYĆ<br />UBEZPIECZENIE REZYGNACJI Z WYJAZDU
              </Typography></Button>
            </Stack>
            <Box height={20} />
          </>
          : null}
        { ((['umowa_zawarta', 'aneks_zawarty'].includes(identifier) && model === 'Order') || identifier === 'karta_kwalifikacyjna') && <Stack direction="column" justifyContent="center" alignItems="center">
          <Box height={40} />
          <Divider sx={{ width: '100%' }}/>
          <Box height={10} />
          <Typography textAlign="center" sx={{ fontSize: 22 }}><i>W międzyczasie obserwuj nas i zawsze bądź na bieżąco</i></Typography>

          <Stack flexDirection="row" gap={2}>
            <a style={{ height: '80px', color: '#4267B2' }} href="https://www.facebook.com/kalisz.sun.sport" target="_blank" rel="noopener noreferrer">
              <FacebookRoundedIcon sx={{ fontSize: 60 }} />
            </a>
            <a style={{ height: '80px' }} href="https://www.instagram.com/sun_sport.pl/" target="_blank" rel="noopener noreferrer">
              <svg width={0} height={0}>
                <radialGradient id="rg" r="150%" cx="30%" cy="107%">
                  <stop stopColor="#fdf497" offset="0" />
                  <stop stopColor="#fdf497" offset="0.05" />
                  <stop stopColor="#fd5949" offset="0.45" />
                  <stop stopColor="#d6249f" offset="0.6" />
                  <stop stopColor="#285AEB" offset="0.9" />
                </radialGradient>
              </svg>
              <InstagramIcon sx={{ fill: 'url(#rg)', fontSize: 60 }}/>
            </a>
            <a style={{ height: '80px', color: 'red' }} href="https://www.youtube.com/@sun_sport_obozy" target="_blank" rel="noopener noreferrer">
              <YouTubeIcon sx={{ fontSize: 60 }} />
            </a>
          </Stack>
        </Stack>
        }
      </Stack>
    </Box>
  );

};
